import { JSX } from 'react';
import { Layout } from '../../components/core';
import { PageContent, PageCrisis } from '../../components/page';
import { EligibilityBlockerContent } from '../../components/therapy/EligibilityBlockerContent';
import { useTitle } from '../../utils/useTitle';

export const TherapyEligibilityPage = (): JSX.Element => {
  useTitle('Therapy Eligibility');

  return (
    <PageContent testID="therapy-eligibility-page">
      <Layout.VStack space={7}>
        <EligibilityBlockerContent showReturnButton={true} testIdPrefix="therapy-eligibility" />
        <PageCrisis />
      </Layout.VStack>
    </PageContent>
  );
};
